import { createFileRoute } from "@tanstack/react-router";

import { EventsList } from "@/components/events";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/events")({
  component: GroupEventsTab,
});

function GroupEventsTab() {
  const { groupId, isAdmin } = useGroupRouteData(Route.useParams().groupId);

  return (
    <div className="mx-auto max-w-180">
      <EventsList groupId={groupId} isAdmin={isAdmin} />
    </div>
  );
}
